module.exports = __webpack_public_path__ + "static/img/userInfoBg.decba2f6.png";